var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarehouse({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33301 14.6665H14.6663",
    stroke: "#004EFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.9668 14.6665L2.00013 6.6465C2.00013 6.23983 2.19346 5.8532 2.51346 5.59987L7.18013 1.96652C7.66013 1.59319 8.33347 1.59319 8.82013 1.96652L13.4868 5.59319C13.8135 5.84653 14.0001 6.23316 14.0001 6.6465V14.6665",
    stroke: "#004EFF",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3337 7.3335H5.66699C5.11366 7.3335 4.66699 7.78016 4.66699 8.3335V14.6668H11.3337V8.3335C11.3337 7.78016 10.887 7.3335 10.3337 7.3335Z",
    stroke: "#004EFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66699 10.8335V11.8335",
    stroke: "#004EFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7 5H9",
    stroke: "#004EFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouse);
export default __webpack_public_path__ + "static/media/Warehouse.7746ee42d77f9c05c1b2d19635de2cf5.svg";
export { ForwardRef as ReactComponent };